export default [
  {
    vid: "01",
    name: "Test1",
    mobileNo: "9825785690",
    emailID: "ABC@gmail.com",
  },
  {
    vid: "02",
    name: "Test2",
    mobileNo: "9824755225",
    emailID: "ABC@gmail.com",
  },
];
